export const visit = (vm, at) => {
at({ "pt-br": { "uiAddonTeams": { "teamSelectLabelOne": "1 equipe selecionada", "teamSelectLabelMany": "{{ count }} equipes selecionadas", "selectTeams": "Selecionar equipes", "selectAll": "Selecionar tudo ({{ teamName }})" } } });
};